import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Glyphicon, Row, Col } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { withTranslation } from 'react-i18next';

class EntitiesList extends Component {
    constructor(props) {
        super(props);
        this.handleSort = this.handleSort.bind(this);
    }

    handleSort(selectedSortKey) {
        const { onFetchData, sortKey, sortDirection } = this.props;
        let selectedSortDirection = 'asc';
        if (selectedSortKey === sortKey) {
            selectedSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
        }
        onFetchData({
            sortKey: selectedSortKey,
            sortDirection: selectedSortDirection
        });
    }

    renderHeaderCell(column, index) {
        const headerText = column.header;
        let headerClick = null, headerIcon = null, headerStyle = null;

        if (column.sortable) {
            const columnSortKey = column.sortKey || (typeof column.accessor === 'string' ? column.accessor : null);

            if (columnSortKey) {
                headerClick = () => this.handleSort(columnSortKey);

                headerStyle = { cursor: 'pointer' };

                const { sortKey, sortDirection } = this.props;
                let headerIconStyle = { float: 'right', color: '#DDDDDD' }, headerIconGlyph = 'sort';
                if (sortKey === columnSortKey) {
                    headerIconStyle.color = '#707070';
                    headerIconGlyph = sortDirection === 'asc' ? 'sort-by-attributes' : 'sort-by-attributes-alt';
                }
                headerIcon = <Glyphicon glyph={headerIconGlyph} style={headerIconStyle} />;
            }
        }

        return (
            <th key={index} onClick={headerClick} style={headerStyle}>
                {headerText}{headerIcon}
            </th>
        );
    }

    renderDataCell(row, column, index) {
        let cellData = '', content = '', cellClassName = '';

        const { accessor, cell, className } = column;

        if (accessor) {
            if (typeof accessor === 'string')
                cellData = this.getNestedValue(row, accessor);

            if (typeof accessor === 'function')
                cellData = accessor(row);
        }

        content = cellData;

        if (cell) {
            content = cell(cellData, row);
        }

        if (className) {
            cellClassName = (typeof className === 'function') ? className(cellData, row) : className;
        }
        return <td key={index} style={{ verticalAlign: 'middle' }} className={cellClassName}>{content}</td>;
    }

    getNestedValue(obj, key) {
        return key.split(".").reduce(function (result, key) {
            if (result) {
                return result[key];
            }
        }, obj);
    }

    render() {
        const { t, columns, data, loading } = this.props;

        const headerCells = columns.map((column, index) => this.renderHeaderCell(column, index));
        const dataCells = row => columns.map((column, index) => this.renderDataCell(row, column, index));

        return <React.Fragment>
            <Row>
                <Col sm={12}>
                    <Table responsive hover>
                        <thead>
                            <tr>{headerCells}</tr>
                        </thead>
                        <tbody>
                            {loading ? <tr><td colSpan={columns.length} style={{ textAlign: 'center' }}><FontAwesome size='2x' name='spinner' spin /> {t('List_Loading')}</td></tr> :
                                ((data && data.length) ? data.map((row, index) => <tr key={index}>{dataCells(row)}</tr>) :
                                    <tr><td colSpan={columns.length}>{t('List_Empty')}</td></tr>)
                            }
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </React.Fragment>;
    }
}

EntitiesList.propTypes = {
    columns: PropTypes.arrayOf(PropTypes.shape({
        header: PropTypes.string,
        sortable: PropTypes.bool,
        accessor: PropTypes.string,
        cell: PropTypes.func
    })),
    onFetchData: PropTypes.func,
    data: PropTypes.array,
    loading: PropTypes.bool,
    sortKey: PropTypes.string,
    sortDirection: PropTypes.string
   };

export default withTranslation()(EntitiesList);